module.exports = __webpack_public_path__ + "img/1583512180.968bc23c.jpg";